import React from 'react';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    title: {
        color: theme.palette.iisightGray700,
        fontWeight: 700,
        fontSize: 12,
        width: "15ch",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    description: {
        fontSize: 12,
        color: theme.palette.iisightDefaultText
    }
}));
export const Details = ({ title, description, ...props }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { ...props },
        title && React.createElement("div", { className: classes.title }, title),
        description && React.createElement("div", { className: classes.description }, description)));
};
